import { AskWhen } from "../../../clients/graphqlTypes.js";

export type RefinementAskWhenContext =
  | "onQuoteRefinement"
  | "onQuoteRefinement2"
  | "onQuoteRefinement3";
export function isRefinementAskWhenContext(
  askWhen: AskWhen
): askWhen is RefinementAskWhenContext {
  return askWhen.startsWith("onQuoteRefinement");
}
